// extracted by mini-css-extract-plugin
module.exports = {"root":"HomeNavigation-module--root--1S4D_","item":"HomeNavigation-module--item--118hu"};